import type { Question, QuestionProperties } from '@api/instant_survey/types';
import { Layout, PillOverlayPopover, Radio } from '@utilities';

import { VW_DISPLAY_ORDERS } from '../../../../utilities/constants';

import styles from './_index.module.scss';

interface QuestionOrderProps {
  question: Question;
  updateQuestionProperties: (properties: Partial<QuestionProperties>) => void;
}

const QuestionOrder = ({ question, updateQuestionProperties }: QuestionOrderProps) => {
  const displayOrder = question.properties.displayOrder ?? VW_DISPLAY_ORDERS.LOW_TO_HIGH.value;

  return (
    <Layout.Flex gap="x-small" style={{ alignItems: 'center' }}>
      <span>Question Order</span>
      <PillOverlayPopover
        overlayClassName={styles['question-order-overlay']}
        value={
          displayOrder === VW_DISPLAY_ORDERS.HIGH_TO_LOW.value
            ? VW_DISPLAY_ORDERS.HIGH_TO_LOW.name
            : VW_DISPLAY_ORDERS.LOW_TO_HIGH.name
        }
      >
        <Layout.Flex.Column gap="small">
          {[VW_DISPLAY_ORDERS.LOW_TO_HIGH, VW_DISPLAY_ORDERS.HIGH_TO_LOW].map((order) => (
            <Radio
              isChecked={displayOrder === order.value}
              key={order.value}
              label={order.name}
              onChange={() => updateQuestionProperties({ displayOrder: order.value })}
              value={order.value}
            />
          ))}
        </Layout.Flex.Column>
      </PillOverlayPopover>
    </Layout.Flex>
  );
};

export default QuestionOrder;
